import { render, staticRenderFns } from "./CommonLocationAddress.vue?vue&type=template&id=22c9e79f"
import script from "./CommonLocationAddress.vue?vue&type=script&lang=js"
export * from "./CommonLocationAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports